import { gql } from "apollo-boost"

export const getMonitoringReportsParticipants = gql`
  query MonitoringReportsParticipants($reports: [ID!]!) {
    MonitoringReportsParticipants(reports: $reports) {
      id
      participants{
        id
        age
        type
        amount
        gender
        preventionLevel
      }
    }
  }
`
